export enum Env {
  WEBVIEW = 'WEBVIEW',
  H5 = 'H5',
}

export enum OperatingSystem {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}

export interface IMediaQuery {
  paddingTop: number;
  paddingBottom: number;
  density: number;
}

export interface ILocation {
  latitude: string;
  longitude: string;
}
